import React, { useEffect, useState } from 'react';
import ModalTemplateB from '../../../../../components/_template/modal/ModalTemplateB';
import BasicButton from '../../../../../components/_atom/button/BasicButton';
import { ButtonTheme } from '../../../../../components/_atom/button/StyledButton';
import CommentInput from '../../../../../components/_atom/input/CommentInput';
import toast from 'react-hot-toast';
import { logic } from '../../../../../../logic';
import { Webhook } from '../../../../../assets/constant/webhookManager.type';

type EditWebhookModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  webhook?: Webhook;
  setWebhook?: (webhook: Webhook) => void;
  refreshWebhook?: () => void;
};
const EditWebhookModal = (props: EditWebhookModalProps) => {
  const { isOpen, closeModal, refreshWebhook, webhook, setWebhook } = props;
  return (
    <ModalTemplateB isOpen={isOpen} title={'Edit Webhook'} showDivideLine={false} onRequestClose={closeModal} shouldCloseOnOverlayClick={false}>
      <EditWebhook
        onClosed={() => {
          closeModal();
          refreshWebhook && refreshWebhook();
        }}
        webhook={webhook}
        setWebhook={setWebhook}
      />
    </ModalTemplateB>
  );
};

export default EditWebhookModal;

const EditWebhook = (props: { onClosed: () => void; webhook?: Webhook; setWebhook?: (webhook: Webhook) => void }) => {
  const { onClosed, webhook, setWebhook } = props;
  const [webhookName, setWebhookName] = useState<string>('');
  const [endpointUrl, setEndpointUrl] = useState<string>('');
  useEffect(() => {
    if (webhook) {
      setWebhookName(webhook.name);
      setEndpointUrl(webhook.webhook_url);
    }
  }, [webhook]);

  const editWebhook = async () => {
    if (!webhook) {
      return;
    }
    const { result, error } = await logic.webhook.updateSubscribeWebhook(webhook?.subscription_id, {
      name: webhookName,
      webhookUrl: endpointUrl,
    });
    if (error) {
      toast.error('Failed to update webhook');
      return;
    }
    setWebhook && setWebhook(result);
    toast.success('Webhook updated successfully');
    onClosed();
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 40, paddingLeft: 10, width: 652 }}>
      <div className="kit-label-value-wrapper column">
        <div className="kit-label">
          Webhook Name
          <div className="kit-label required">*</div>
        </div>
        <CommentInput
          value={webhookName}
          style={{ paddingLeft: 10 }}
          placeholder={'Enter the name of the webhook'}
          onChange={(e) => {
            setWebhookName(e.target.value.trimStart());
          }}
        />
      </div>
      <div className="kit-label-value-wrapper column">
        <div className="kit-label">
          Endpoint URL
          <div className="kit-label required">*</div>
        </div>
        <CommentInput
          value={endpointUrl}
          style={{ paddingLeft: 10 }}
          placeholder={'https://'}
          onChange={(e) => {
            setEndpointUrl(e.target.value.trimStart());
          }}
        />
      </div>
      <div className="kit-label-value-wrapper column">
        <div className="kit-label">Service</div>
        <div className="kit-value" style={{ paddingLeft: 10 }}>
          {webhook?.resource_subscriptions[0]?.service_identifier === 'TOKEN_KIT' ? 'Token Kit' : 'Transaction'}
        </div>
      </div>
      <div className="kit-label-value-wrapper column">
        <div className="kit-label">Event Type</div>
        <div className="kit-value" style={{ paddingLeft: 10 }}>
          {webhook?.event_name}
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10 }}>
        <BasicButton theme={ButtonTheme.NORMAL} onClick={onClosed}>
          Close
        </BasicButton>
        <BasicButton theme={ButtonTheme.PRIMARY} onClick={editWebhook} disabled={!webhookName || !endpointUrl}>
          Save
        </BasicButton>
      </div>
    </div>
  );
};
